export default __webpack_public_path__ + "static/media/TIRPA.af93f415.png";